import {
  Wallet, ShoppingCart, Briefcase, House, Receipt, Users, Package, Tag, Coffee, Utensils, Car, Fuel, Zap,
  Droplet, Wifi, Phone, Truck, Gift, Heart, Banknote, CreditCard, Landmark, Store, Shirt, Wrench, Pill,
  BookOpen, Plane, PiggyBank, Scissors, Hammer, Baby, Dog, Music, Megaphone, GraduationCap,
} from "lucide-react";

export const ICONS = {
  wallet: Wallet, "shopping-cart": ShoppingCart, briefcase: Briefcase, home: House, receipt: Receipt,
  users: Users, package: Package, tag: Tag, coffee: Coffee, utensils: Utensils, car: Car, fuel: Fuel,
  zap: Zap, droplet: Droplet, wifi: Wifi, phone: Phone, truck: Truck, gift: Gift, heart: Heart,
  banknote: Banknote, "credit-card": CreditCard, landmark: Landmark, store: Store, shirt: Shirt,
  wrench: Wrench, pill: Pill, book: BookOpen, plane: Plane, "piggy-bank": PiggyBank, scissors: Scissors,
  hammer: Hammer, baby: Baby, dog: Dog, music: Music, megaphone: Megaphone, education: GraduationCap,
};

export function CategoryIcon({ name, type, opening, size = "md" }) {
  const Icon = ICONS[name] || Tag;
  const tone = opening
    ? "bg-sky-100 text-sky-700"
    : type === "income"
    ? "bg-emerald-100 text-emerald-700"
    : "bg-rose-100 text-rose-700";
  const box = size === "sm" ? "h-8 w-8" : "h-10 w-10";
  return (
    <span className={`inline-flex shrink-0 items-center justify-center rounded-xl ${box} ${tone}`}>
      <Icon className={size === "sm" ? "h-4 w-4" : "h-5 w-5"} />
    </span>
  );
}
